import { render, staticRenderFns } from "./ShebaConfirmation.vue?vue&type=template&id=51a98bd0"
import script from "./ShebaConfirmation.vue?vue&type=script&lang=js"
export * from "./ShebaConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports